export default class PausedOverlay {
    /**
     * @constructor
     * @param {HTMLDivElement} overlay - Overlay DOM
     * @param {HTMLDivElement} playButton - Play button DOM
     */
    constructor(overlay, playButton) {
        this._overlay = overlay;
        this._playButton = playButton;

        this._dispatcher = new createjs.EventDispatcher();

        this.addEventListeners();
    }

    destroy() {
        this.removeEventListeners();
    }

    addEventListeners() {
        this._handleOverlayBound = this._handleOverlay.bind(this);
        this._overlay.addEventListener('click', this._handleOverlayBound);
    }

    removeEventListeners() {
        this._overlay.removeEventListener('click', this._handleOverlayBound);
    }

    show() {
        const targetStyle = {
            opacity: 1
        };

        if (this._styleRequiresChange(targetStyle)) {
            // Control CSS properties with a CreateJS tween.
            // When the tween advances it will call the _render method which updates the CSS properties of the overlay DOM object.
            // If you want to animate other properties you can add them to the animation scope by adding them in the targetStyle's and the _getCurrentStyleData method.
            createjs.Tween.get(this._getCurrentStyleData(), { onChange: this._render.bind(this) })
                .to(targetStyle, 450, createjs.Ease.sineInOut);

            // Removes the CSS path drawing animation from the play button
            const paths = this._playButton.getElementsByTagName('path');
            for (let i = 0; i < paths.length; i++) {
                const path = paths[i];
                path.style.animation = null;
            }

            createjs.Tween.get(this._playButton)
                .wait(150)
                .call(() => {
                    // Start the CSS path drawing animation for the play button
                    for (let i = 0; i < paths.length; i++) {
                        const path = paths[i];
                        path.style.animation = 'draw .65s forwards';
                    }
                });
        }

        // Enables the the overlay to be clicked, this will eat clicks meaning the canvas will not receive click events.
        this._overlay.style.pointerEvents = 'all';
    }

    hide() {
        const targetStyle = {
            opacity: 0
        };
        if (this._styleRequiresChange(targetStyle)) {
            createjs.Tween.get(this._getCurrentStyleData(), { onChange: this._render.bind(this) })
                .to(targetStyle, 450, createjs.Ease.sineInOut);
        }

        // Disables clicks on the overlay, allowing the canvas beneath it to be clicked.
        this._overlay.style.pointerEvents = 'none';
    }

    
    /**
     * Renders CSS properties on the object that the event targets.
     * This method should be hooked to the `onChange` TweenJS listener.
     * @param {createjs.Event} evt
     */
    _render(evt) {
        var data = evt.currentTarget.target;
        this._overlay.style.opacity = data.opacity;
    }

    _styleRequiresChange(targetStyleData) {
        return JSON.stringify(targetStyleData) !== JSON.stringify(this._getCurrentStyleData());
    }

    _getCurrentStyleData() {
        let opacity = parseFloat(this._overlay.style.opacity) || 0;

        return {
            opacity
        };
    }

    _handleOverlay(evt) {
        this.dispatcher.dispatchEvent(PausedOverlay.CLICK);
    }

    get dispatcher() {
        return this._dispatcher;
    }
}

PausedOverlay.CLICK = "click";